import { motion } from "framer-motion";
import { useT } from "@/i18n/LanguageProvider";

export default function Story() {
  const { t } = useT();
  return (
    <section
      id="story"
      data-testid="story-section"
      className="relative w-full bg-[#FFF8EE] py-28 md:py-44"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20">
        <div className="md:col-span-5">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.7 }}
            className="label-tracked text-[#7B5C4E]"
            data-testid="story-eyebrow"
          >
            {t("story.eyebrow")}
          </motion.p>

          <motion.div
            initial={{ scaleY: 0 }}
            whileInView={{ scaleY: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.2 }}
            className="mt-6 w-px h-24 origin-top"
            style={{ background: "#C5A059" }}
          />
        </div>

        <div className="md:col-span-7">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
            data-testid="story-headline"
            className="font-serif font-light text-[#211512] leading-[1] tracking-tight"
            style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}
          >
            {t("story.headline_1")}
            <br />
            <span className="italic" style={{ color: "#7B5C4E" }}>
              {t("story.headline_2")}
            </span>
          </motion.h2>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-10 max-w-3xl">
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-[#211512]/80 leading-relaxed text-base"
              data-testid="story-paragraph-1"
            >
              {t("story.p1")}
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.35 }}
              className="text-[#211512]/80 leading-relaxed text-base"
              data-testid="story-paragraph-2"
            >
              {t("story.p2")}
            </motion.p>
          </div>

          
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div data-testid={`story-stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <p
        className="font-serif text-[#211512]"
        style={{ fontSize: "clamp(2rem, 3.5vw, 3rem)", lineHeight: 1 }}
      >
        {number}
      </p>
      <p className="label-tracked mt-3 text-[#7B5C4E]">{label}</p>
    </div>
  );
}
